<template>
  <div class="architectPage">
    <Head />
    <Box1 />
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6new />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box14 />
    <Foot />
  </div>
</template>

<script>
import Head from "../../components/common/head.vue";
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6new from "./Box6new.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box14 from "./Box14.vue";
import Foot from "../../components/common/foot.vue";

export default {
  components: {
    Head,
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box6new,
    Box7,
    Box8,
    Box9,
    Box10,
    Box14,
    Foot,
  },
  data() {
    return {};
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    itcastClick() {
      qimoChatClick();
    }
  },
};
</script>

<style lang="scss" scoped>
.architectPage {
  width: 750px;
  position: relative;
}
</style>
